import { FeedbackSchema, IMAGE_UPLOAD_LIMIT } from '@feedback-service/shared';
import { z } from 'zod';

export const feedbackFormSchema = FeedbackSchema.extend({
  images: z.array(z.instanceof(File)).max(IMAGE_UPLOAD_LIMIT.maxCount, 'form.images.max').optional(),
});

export type FeedbackFormData = z.infer<typeof feedbackFormSchema>;
